/* NILO V5.13.73 — Isolated product-image lightbox. No cart, variant, COD or gallery-scroll changes. */
(function () {
  'use strict';
  function init() {
    var page = document.querySelector('[data-nilo-product-page]');
    if (!page || page.dataset.niloZoomReady === '1') return;
    var gallery = page.querySelector('[data-nilo-product-gallery]');
    if (!gallery) return;
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('.nilo-product-gallery__slide'));
    var photos = slides.map(function (slide, i) {
      var img = slide.querySelector('img');
      return img && { index: i, image: img, src: slide.getAttribute('data-nilo-zoom-src') || img.currentSrc || img.src, alt: img.alt || '' };
    }).filter(Boolean);
    if (!photos.length) return;
    page.dataset.niloZoomReady = '1';
    var rtl = document.documentElement.dir === 'rtl' || (window.getComputedStyle(page).direction === 'rtl');
    var label = rtl ? {
      open: 'كبري الصورة', close: 'سدّي الصورة', next: 'الصورة الجاية', previous: 'الصورة اللي فاتت', plus: 'كبّري', minus: 'صغّري', reset: 'رجعي الحجم الأصلي', hint: 'قربي بجوج صباعك باش تشوفي التفاصيل', photos: 'صور المنتوج'
    } : {
      open: 'Agrandir la photo', close: 'Fermer la photo', next: 'Photo suivante', previous: 'Photo précédente', plus: 'Zoom avant', minus: 'Zoom arrière', reset: 'Taille normale', hint: 'Pincez ou double-touchez pour zoomer', photos: 'Photos du produit'
    };
    var iconZoom = '<svg viewBox="0 0 24 24" width="19" height="19" fill="none" stroke="currentColor" stroke-width="1.85" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="10.75" cy="10.75" r="6.75"/><path d="m16 16 5 5M8 10.75h5.5m-2.75-2.75v5.5"/></svg>';
    slides.forEach(function (slide) {
      if (!slide.querySelector('img') || slide.querySelector('.nilo-zoom-trigger')) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'nilo-zoom-trigger';
      btn.setAttribute('aria-label', label.open);
      btn.innerHTML = iconZoom + '<span>' + label.open + '</span>';
      slide.appendChild(btn);
    });

    var overlay = document.createElement('div');
    overlay.className = 'nilo-zoom-modal';
    overlay.hidden = true;
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', label.photos);
    overlay.setAttribute('dir', rtl ? 'rtl' : 'ltr');
    overlay.innerHTML = '<div class="nilo-zoom-top">'
      + '<div class="nilo-zoom-brand"><strong>nilo</strong><span class="nilo-zoom-current" aria-live="polite">1 / ' + photos.length + '</span></div>'
      + '<button class="nilo-zoom-close" type="button" data-zoom-close aria-label="' + label.close + '"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 5 19 19M19 5 5 19"/></svg></button>'
      + '</div><div class="nilo-zoom-stage" data-zoom-stage>'
      + '<button class="nilo-zoom-arrow nilo-zoom-arrow--left" type="button" data-zoom-left aria-label="' + (rtl ? label.next : label.previous) + '"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m14.5 4-8 8 8 8"/></svg></button>'
      + '<img class="nilo-zoom-image" data-zoom-image draggable="false" alt="">'
      + '<button class="nilo-zoom-arrow nilo-zoom-arrow--right" type="button" data-zoom-right aria-label="' + (rtl ? label.previous : label.next) + '"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9.5 4 8 8-8 8"/></svg></button>'
      + '</div><div class="nilo-zoom-bottom">'
      + '<div class="nilo-zoom-tools"><span class="nilo-zoom-hint">' + label.hint + '</span>'
      + '<div class="nilo-zoom-tool-buttons"><button type="button" data-zoom-minus aria-label="' + label.minus + '">−</button>'
      + '<button type="button" data-zoom-reset aria-label="' + label.reset + '"><span data-zoom-level>100%</span></button>'
      + '<button type="button" data-zoom-plus aria-label="' + label.plus + '">+</button></div></div>'
      + '<div class="nilo-zoom-thumbs" data-zoom-thumbs role="group" aria-label="' + label.photos + '"></div></div>';
    document.body.appendChild(overlay);
    var stage = overlay.querySelector('[data-zoom-stage]');
    var image = overlay.querySelector('[data-zoom-image]');
    var current = overlay.querySelector('.nilo-zoom-current');
    var thumbRail = overlay.querySelector('[data-zoom-thumbs]');
    var level = overlay.querySelector('[data-zoom-level]');
    var zoomButtons = Array.prototype.slice.call(thumbRail.children);
    var activeIndex = 0;
    var scale = 1, tx = 0, ty = 0;
    var maxScale = 3.5;
    var previousFocus = null, scrollY = 0, oldBodyStyles = null;
    var pointers = new Map(), dragBase = null, pinchBase = null, lastTap = 0, lastTapPos = null, gestureMoved = false, lastPointerType = 'mouse';
    var isOpen = false;

    photos.forEach(function (photo, index) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'nilo-zoom-thumb';
      btn.dataset.zoomIndex = index;
      btn.setAttribute('aria-label', (rtl ? 'الصورة ' : 'Photo ') + (index + 1));
      var small = document.createElement('img');
      small.alt = '';
      small.src = photo.image.currentSrc || photo.image.src;
      small.loading = 'lazy';
      btn.appendChild(small);
      btn.addEventListener('click', function () { show(index); });
      thumbRail.appendChild(btn);
    });
    zoomButtons = Array.prototype.slice.call(thumbRail.children);

    function clamp(n, min, max) { return Math.max(min, Math.min(max, n)); }
    function boundPan() {
      if (scale <= 1.001) { tx = 0; ty = 0; return; }
      var w = image.offsetWidth || stage.clientWidth;
      var h = image.offsetHeight || stage.clientHeight;
      var xLimit = Math.max(0, w * (scale - 1) / 2);
      var yLimit = Math.max(0, h * (scale - 1) / 2);
      tx = clamp(tx, -xLimit, xLimit);
      ty = clamp(ty, -yLimit, yLimit);
    }
    function render() {
      boundPan();
      image.style.transform = 'translate3d(calc(-50% + ' + tx + 'px),calc(-50% + ' + ty + 'px),0) scale(' + scale + ')';
      stage.classList.toggle('is-zoomed', scale > 1.001);
      level.textContent = Math.round(scale * 100) + '%';
    }
    function resetZoom() { scale = 1; tx = 0; ty = 0; pointers.clear(); dragBase = null; pinchBase = null; render(); }
    function zoomTo(nextScale, centerX, centerY) {
      var newScale = clamp(nextScale, 1, maxScale);
      if (newScale === scale) return;
      var rect = stage.getBoundingClientRect();
      var cx = typeof centerX === 'number' ? centerX - rect.left - rect.width / 2 : 0;
      var cy = typeof centerY === 'number' ? centerY - rect.top - rect.height / 2 : 0;
      var ratio = newScale / scale;
      tx = cx - (cx - tx) * ratio;
      ty = cy - (cy - ty) * ratio;
      scale = newScale;
      render();
    }
    function show(index) {
      if (!isOpen) return;
      activeIndex = (index + photos.length) % photos.length;
      var photo = photos[activeIndex];
      resetZoom();
      image.alt = photo.alt;
      image.src = photo.src;
      current.textContent = (activeIndex + 1) + ' / ' + photos.length;
      zoomButtons.forEach(function (btn, n) {
        var active = n === activeIndex;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-current', active ? 'true' : 'false');
      });
      var activeThumb = zoomButtons[activeIndex];
      if (activeThumb && activeThumb.scrollIntoView) activeThumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'auto' });
      overlay.querySelector('[data-zoom-left]').disabled = photos.length < 2;
      overlay.querySelector('[data-zoom-right]').disabled = photos.length < 2;
    }
    function navigate(direction) {
      if (photos.length < 2) return;
      show(activeIndex + direction);
    }
    function start(index) {
      if (isOpen) return;
      previousFocus = document.activeElement;
      scrollY = window.scrollY || window.pageYOffset || 0;
      oldBodyStyles = {
        position: document.body.style.position, top: document.body.style.top,
        left: document.body.style.left, right: document.body.style.right,
        width: document.body.style.width, overflow: document.body.style.overflow
      };
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + scrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
      overlay.hidden = false;
      isOpen = true;
      show(index);
      overlay.querySelector('[data-zoom-close]').focus({ preventScroll: true });
    }
    function close() {
      if (!isOpen) return;
      isOpen = false;
      overlay.hidden = true;
      /* Keep the underlying gallery on the last inspected photograph. */
      var slide = slides[photos[activeIndex].index];
      if (slide) {
        var railFrame = gallery.getBoundingClientRect();
        var slideFrame = slide.getBoundingClientRect();
        var railRtl = window.getComputedStyle(gallery).direction === 'rtl';
        var delta = railRtl ? slideFrame.right - railFrame.right : slideFrame.left - railFrame.left;
        gallery.scrollTo({ left: gallery.scrollLeft + delta, behavior: 'auto' });
      }
      resetZoom();
      image.removeAttribute('src');
      if (oldBodyStyles) Object.keys(oldBodyStyles).forEach(function (key) { document.body.style[key] = oldBodyStyles[key]; });
      window.scrollTo(0, scrollY);
      if (previousFocus && previousFocus.isConnected && previousFocus.focus) previousFocus.focus({ preventScroll: true });
    }
    overlay.querySelector('[data-zoom-close]').addEventListener('click', close);
    overlay.querySelector('[data-zoom-left]').addEventListener('click', function () { navigate(rtl ? 1 : -1); });
    overlay.querySelector('[data-zoom-right]').addEventListener('click', function () { navigate(rtl ? -1 : 1); });
    overlay.querySelector('[data-zoom-plus]').addEventListener('click', function () { zoomTo(scale + .75); });
    overlay.querySelector('[data-zoom-minus]').addEventListener('click', function () { zoomTo(scale - .75); });
    overlay.querySelector('[data-zoom-reset]').addEventListener('click', resetZoom);
    image.addEventListener('load', render);
    image.addEventListener('error', function () {
      var fallback = photos[activeIndex] && (photos[activeIndex].image.currentSrc || photos[activeIndex].image.src);
      if (fallback && image.src !== fallback) image.src = fallback;
    });
    stage.addEventListener('dblclick', function (event) {
      if (event.target.closest('button')) return;
      event.preventDefault();
      if (lastPointerType === 'touch') return; // iOS can synthesize dblclick after two taps.
      zoomTo(scale > 1.05 ? 1 : 2.25, event.clientX, event.clientY);
    });
    stage.addEventListener('wheel', function (event) {
      if (!isOpen || event.target.closest('button')) return;
      event.preventDefault();
      zoomTo(scale + (event.deltaY < 0 ? .25 : -.25), event.clientX, event.clientY);
    }, { passive: false });

    function xy(points) {
      var p = Array.from(points.values());
      return { x: (p[0].x + p[1].x) / 2, y: (p[0].y + p[1].y) / 2,
        distance: Math.hypot(p[1].x - p[0].x, p[1].y - p[0].y) };
    }
    stage.addEventListener('pointerdown', function (event) {
      if (!isOpen || event.target.closest('button') || event.pointerType === 'mouse' && event.button !== 0) return;
      if (event.cancelable) event.preventDefault();
      lastPointerType = event.pointerType;
      pointers.set(event.pointerId, { x: event.clientX, y: event.clientY, startX: event.clientX, startY: event.clientY });
      gestureMoved = false;
      try { stage.setPointerCapture(event.pointerId); } catch (_) {}
      if (pointers.size === 1) {
        dragBase = { x: event.clientX, y: event.clientY, tx: tx, ty: ty, t: Date.now() };
        pinchBase = null;
      } else if (pointers.size === 2) {
        var pair = xy(pointers);
        pinchBase = { distance: Math.max(12, pair.distance), scale: scale, tx: tx, ty: ty, x: pair.x, y: pair.y };
        dragBase = null;
      }
    });
    stage.addEventListener('pointermove', function (event) {
      if (!isOpen || !pointers.has(event.pointerId)) return;
      var p = pointers.get(event.pointerId);
      p.x = event.clientX; p.y = event.clientY;
      if (Math.hypot(p.x - p.startX, p.y - p.startY) > 10) gestureMoved = true;
      if (pointers.size >= 2 && pinchBase) {
        var pair = xy(pointers);
        var factor = pair.distance / pinchBase.distance;
        var nextScale = clamp(pinchBase.scale * factor, 1, maxScale);
        var rect = stage.getBoundingClientRect();
        var midX = pinchBase.x - rect.left - rect.width / 2;
        var midY = pinchBase.y - rect.top - rect.height / 2;
        var ratio = nextScale / pinchBase.scale;
        scale = nextScale;
        tx = pair.x - rect.left - rect.width / 2 - (midX - pinchBase.tx) * ratio;
        ty = pair.y - rect.top - rect.height / 2 - (midY - pinchBase.ty) * ratio;
        render();
      } else if (pointers.size === 1 && dragBase && scale > 1.001) {
        tx = dragBase.tx + event.clientX - dragBase.x;
        ty = dragBase.ty + event.clientY - dragBase.y;
        render();
      }
    });
    function endPointer(event) {
      if (!pointers.has(event.pointerId)) return;
      var p = pointers.get(event.pointerId);
      var drag = dragBase;
      var touchedTwo = !!pinchBase;
      pointers.delete(event.pointerId);
      if (pointers.size === 0) {
        if (!touchedTwo && scale <= 1.001 && drag) {
          var dx = event.clientX - drag.x;
          var dy = event.clientY - drag.y;
          if (Math.abs(dx) > 65 && Math.abs(dx) > Math.abs(dy) * 1.3) navigate((rtl ? -1 : 1) * (dx < 0 ? 1 : -1));
          else if (event.pointerType === 'touch' && Math.abs(dx) < 12 && Math.abs(dy) < 12) {
            var now = Date.now();
            if (now - lastTap < 320 && lastTapPos && Math.hypot(lastTapPos.x - event.clientX, lastTapPos.y - event.clientY) < 48) {
              zoomTo(scale > 1.05 ? 1 : 2.25, event.clientX, event.clientY);
              lastTap = 0;
            } else { lastTap = now; lastTapPos = { x: event.clientX, y: event.clientY }; }
          }
        } else if (!touchedTwo && scale > 1.001 && event.pointerType === 'touch') {
          var nowZoom = Date.now();
          if (nowZoom - lastTap < 320 && lastTapPos && Math.hypot(lastTapPos.x - event.clientX, lastTapPos.y - event.clientY) < 48) {
            zoomTo(1);
            lastTap = 0;
          } else { lastTap = nowZoom; lastTapPos = { x: event.clientX, y: event.clientY }; }
        }
        dragBase = null; pinchBase = null;
      } else if (pointers.size === 1) {
        var rest = Array.from(pointers.values())[0];
        dragBase = { x: rest.x, y: rest.y, tx: tx, ty: ty, t: Date.now() };
        pinchBase = null;
      }
    }
    stage.addEventListener('pointerup', endPointer);
    stage.addEventListener('pointercancel', endPointer);
    document.addEventListener('keydown', function (event) {
      if (!isOpen) return;
      if (event.key === 'Escape') { event.preventDefault(); close(); }
      if (event.key === 'ArrowRight') { event.preventDefault(); navigate(rtl ? -1 : 1); }
      if (event.key === 'ArrowLeft') { event.preventDefault(); navigate(rtl ? 1 : -1); }
      if (event.key === '+' || event.key === '=') { event.preventDefault(); zoomTo(scale + .75); }
      if (event.key === '-' || event.key === '_') { event.preventDefault(); zoomTo(scale - .75); }
      if (event.key === 'Tab') {
        var focusables = Array.prototype.slice.call(overlay.querySelectorAll('button:not([disabled])'));
        if (!focusables.length) return;
        var first = focusables[0], last = focusables[focusables.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    });
    var startPos = null;
    gallery.addEventListener('pointerdown', function (event) {
      startPos = { x: event.clientX, y: event.clientY, time: Date.now() };
    }, { passive: true });
    gallery.addEventListener('click', function (event) {
      var slide = event.target.closest('.nilo-product-gallery__slide');
      if (!slide || !gallery.contains(slide)) return;
      if (!event.target.closest('img,.nilo-image-watermark,.nilo-zoom-trigger')) return;
      if (startPos && (Math.hypot(event.clientX - startPos.x, event.clientY - startPos.y) > 14)) return;
      event.preventDefault();
      event.stopPropagation();
      var index = slides.indexOf(slide);
      var photoIndex = photos.findIndex(function (photo) { return photo.index === index; });
      if (photoIndex >= 0) start(photoIndex);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
